<template>
    <auth-shell
        image="/login-image.png"
        image-alt="Profissional de saúde sorrindo"
    >
        <template #visualContent>
            <eyebrow primary class="mb-2" style="color: rgba(255,255,255,0.85)">
                Future Marketing
            </eyebrow>
            <h2 class="auth-shell__pitch">
                A inteligência por trás dos sites de saúde que crescem.
            </h2>
            <p class="auth-shell__pitch-sub">
                SEO, conteúdo e presença digital — para você focar no que importa.
            </p>
        </template>

        <v-slide-x-reverse-transition leave-absolute>
            <v-form
                v-if="mode === 'forgot_password'"
                class="login-form"
                @submit.prevent="resetPassword"
            >
                <eyebrow strong class="mb-2">Recuperação</eyebrow>
                <h1 class="login-form__title">Esqueceu sua senha?</h1>
                <p class="login-form__subtitle">
                    Informe seu e-mail e vamos enviar instruções para você redefinir.
                </p>

                <div class="login-form__icon-decor">
                    <v-icon
                        size="64"
                        color="primary"
                    >
                        mdi-email-fast-outline
                    </v-icon>
                </div>

                <v-text-field
                    v-model="email"
                    label="Email"
                    outlined
                    hide-details="auto"
                    autocomplete="email"
                    class="mb-4"
                />

                <v-btn
                    depressed
                    large
                    color="primary"
                    block
                    type="submit"
                    class="mb-4"
                >
                    Enviar instruções
                </v-btn>

                <div class="login-form__footer">
                    <span class="text-muted">Lembrou a senha?</span>
                    <a
                        class="login-form__link"
                        @click="mode = 'login'"
                    >
                        Voltar ao login
                    </a>
                </div>
            </v-form>
        </v-slide-x-reverse-transition>

        <v-slide-x-transition leave-absolute>
            <v-form
                v-if="mode !== 'forgot_password'"
                class="login-form"
                @submit.prevent="login"
            >
                <eyebrow strong class="mb-2">Acesso</eyebrow>
                <h1 class="login-form__title">Bem-vindo de volta</h1>
                <p class="login-form__subtitle">
                    Faça seu login para acessar a plataforma.
                </p>

                <v-text-field
                    v-model="email"
                    label="Email"
                    outlined
                    hide-details="auto"
                    autocomplete="email"
                    class="mb-3"
                />

                <v-text-field
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    label="Senha"
                    outlined
                    hide-details="auto"
                    autocomplete="current-password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    class="mb-2"
                    @click:append="showPassword = !showPassword"
                />

                <div class="d-flex align-center justify-space-between flex-wrap mb-5" style="gap:8px">
                    <v-checkbox
                        v-model="remember"
                        label="Lembrar-me"
                        hide-details
                        class="mt-0 pt-0"
                    />
                    <a
                        class="login-form__link"
                        @click="mode = 'forgot_password'"
                    >
                        Esqueceu sua senha?
                    </a>
                </div>

                <v-btn
                    depressed
                    large
                    color="primary"
                    block
                    type="submit"
                >
                    Entrar
                </v-btn>
            </v-form>
        </v-slide-x-transition>
    </auth-shell>
</template>

<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";

export default {
    name: "LoginView",
    data() {
        return {
            mode: "login",
            email: "",
            password: "",
            remember: true,
            showPassword: false,
        };
    },
    methods: {
        async login() {
            const response = await Api.login(this.email, this.password, this.remember);

            if (response.error) {
                this.$toast('error', response.message);
                return
            }

            const redirectUrl = this.$route.query.redirect || '/';
            this.$router.push(redirectUrl);
        },
        async resetPassword() {
            const resp = await Api.recoveryPassword(this.email);

            if (resp && !resp.error && resp.message) {
                emitToastr('success', 'Email enviado com sucesso!');
                this.mode = 'login'
            }
        }
    },
};
</script>

<style scoped>
.auth-shell__pitch {
    font-family: var(--font-display);
    font-weight: 800;
    font-size: 1.5rem;
    line-height: 1.2;
    letter-spacing: -0.01em;
    margin: 0 0 8px;
    color: #fff;
}

.auth-shell__pitch-sub {
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 0;
    color: rgba(255, 255, 255, 0.85);
    max-width: 420px;
}

.login-form {
    width: 100%;
    max-width: 380px;
    margin: 0 auto;
}

.login-form__title {
    font-family: var(--font-display);
    font-weight: 800;
    font-size: 1.75rem;
    line-height: 1.15;
    letter-spacing: -0.01em;
    margin: 0 0 8px;
    color: var(--color-on-surface);
}

.login-form__subtitle {
    font-size: 0.875rem;
    line-height: 1.5;
    color: var(--color-on-surface-variant);
    margin: 0 0 24px;
}

.login-form__icon-decor {
    display: flex;
    justify-content: center;
    margin: 8px 0 16px;
}

.login-form__footer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    font-size: 0.8125rem;
}

.login-form__link {
    color: var(--color-primary);
    font-weight: 700;
    font-size: 0.8125rem;
    text-decoration: none;
    cursor: pointer;
}

.login-form__link:hover {
    text-decoration: underline;
}
</style>
